export const SITE = {
  brand: "Knight Insurance Solutions",
  phone: "(513) 443-1300",
  toll_free: "1 (888) 93-KNIGHT",
  toll_free_tel: "18889356444",
  fax: "1 (513) 399-4989",
  address_line: "8465 Colerain Ave.",
  address_city: "Cincinnati, Ohio 45239",
  email: "damon.knight@knightinssolutions.com",
  cta_primary: "Get A Quote",
  socials: [
    { name: "Instagram", icon: "instagram", href: "https://instagram.com/knightinssolutions" },
    { name: "Threads", icon: "threads", href: "https://threads.net/@knightinssolutions" },
    { name: "Facebook", icon: "facebook", href: "https://facebook.com/knightinssolutions" },
    { name: "X", icon: "x", href: "https://x.com/knightinssol" },
    { name: "TikTok", icon: "tiktok", href: "https://tiktok.com/@knightinssolutions" },
    { name: "YouTube", icon: "youtube", href: "https://youtube.com/@knightinssolutions" },
  ],
  logo_image: "/knight-logo.png",
  hero_video: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/vv12iva1_file.mp4",
  hero_bg: "https://static.wixstatic.com/media/11062b_5666ab8edbab4ef08b1a9766fac59429f000.jpg/v1/fill/w_1905,h_760,al_c,q_85,usm_0.33_1.00_0.00,enc_avif,quality_auto/11062b_5666ab8edbab4ef08b1a9766fac59429f000.jpg",
  why_bg: "https://static.wixstatic.com/media/7a755a_4e177aa65435461981d33f607c7d482c~mv2.jpg",
  team: [
    {
      name: "Damon Knight",
      role: "Agency Principal",
      email: "damon.knight@knightinssolutions.com",
      phone: "(513) 443-1300 Ex. 101",
      image:
        "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/fb39x7cd_IMG_8259.png",
    },
    {
      name: "Brooke Knight",
      role: "VP of Operations",
      email: "brooke.knight@knightinssolutions.com",
      phone: "(513) 443-1300 Ex. 102",
      image:
        "https://static.wixstatic.com/media/7a755a_67ab0d33e15947a29d840033b5fa233f~mv2.jpeg/v1/crop/x_0,y_0,w_1792,h_2192/fill/w_624,h_676,al_c,q_85,enc_avif,quality_auto/BNKHS5.jpeg",
    },
    {
      name: "Nora Lee Smith",
      role: "Office Manager",
      email: "nleesmith@knightinssolutions.com",
      phone: "(513) 443-1300 Ex. 103",
      image:
        "https://static.wixstatic.com/media/7a755a_b9a854f8e80c4e21bc8321c4be65e2e9~mv2.png/v1/fill/w_650,h_660,al_c,q_85,enc_avif,quality_auto/AiOMHS.png",
    },
  ],
  carriers: [
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/3lhy6y84_____9903721.jpg", blend: "multiply" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/fa8jf478_____8760419.jpg", blend: "multiply" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/qh0m33vd_____8349060.jpg", blend: "multiply" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/kbz8hf6h_____6587830.jpg", blend: "multiply" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/vq3oqhgm_____5456516.jpg", blend: "multiply" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/aih852k3_progressive.png", blend: "screen" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/m1igh1lc_GEICO-Logo-1536x405.png", blend: "screen" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/l9hnmajc_nationwide_1.png", blend: "multiply" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/ak1nwcdl_metlife_1.png", blend: "multiply" },
    { src: "https://customer-assets.emergentagent.com/job_modern-knight-ins/artifacts/r47xvuvv_libertymutual_1.png", blend: "multiply" },
  ],
  services: [
    {
      slug: "auto",
      href: "/auto-insurance",
      title: "Auto Insurance",
      blurb:
        "Liability, collision and comprehensive coverage built around the way you drive.",
      image:
        "https://static.wixstatic.com/media/7a755a_d9e1bb0e31bb43c58cfc16c8ba117357~mv2.jpg/v1/fill/w_900,h_600,al_c,q_85,enc_avif,quality_auto/happy-family-3.jpg",
    },
    {
      slug: "home",
      href: "/homeowners-insurance",
      title: "Homeowners",
      blurb:
        "Protect the place you call home — dwelling, contents, liability and more.",
      image:
        "https://static.wixstatic.com/media/7a755a_748e497481874b0cafe402e787e97734~mv2.jpg/v1/fill/w_900,h_600,al_c,q_85,enc_avif,quality_auto/download_edited.jpg",
    },
    {
      slug: "life",
      href: "/life-insurance",
      title: "Life Insurance",
      blurb:
        "Term and whole life policies that safeguard the people who matter most.",
      image:
        "https://static.wixstatic.com/media/7a755a_3be0639153904c4285a69cd129209537~mv2.jpg/v1/fill/w_900,h_600,al_c,q_85,enc_avif,quality_auto/grandpa-and-kids.jpg",
    },
    {
      slug: "health",
      href: "/health-insurance",
      title: "Health Insurance",
      blurb:
        "Individual, family and Medicare plans tailored to your life stage.",
      image:
        "https://static.wixstatic.com/media/7a755a_da21c3c2ed104520b3348849bd0e444f~mv2.jpg/v1/fill/w_900,h_600,al_c,q_85,enc_avif,quality_auto/Health%20Insurance.jpg",
    },
    {
      slug: "business",
      href: "/business-insurance",
      title: "Business Insurance",
      blurb:
        "General liability, BOP, commercial auto and workers' comp for any size operation.",
      image:
        "https://static.wixstatic.com/media/7a755a_6fa9eef2c68446fc89339a6fec03aa60~mv2.jpg/v1/fill/w_900,h_600,al_c,q_85,enc_avif,quality_auto/business-woman.jpg",
    },
    {
      slug: "other",
      href: "/specialty-insurance",
      title: "Specialty & Other",
      blurb:
        "Umbrella, motorcycle, watercraft, RV — and bespoke financial protection.",
      image:
        "https://static.wixstatic.com/media/7a755a_87d114dbdc5c4ba2aa48dca8e6b92195~mv2.jpg/v1/fill/w_900,h_600,al_c,q_85,enc_avif,quality_auto/The-Role-the-Financial-Advisor-in-Insurance-scaled-e1674234510381-2048x1065-1.jpg",
    },
  ],
  reasons: [
    { title: "Variety of Options", desc: "Quote multiple carriers in a single conversation." },
    { title: "Tailored Coverage", desc: "Coverage shaped around your life — not a template." },
    { title: "Flexibility", desc: "Re-shop and re-quote as your needs evolve." },
    { title: "Adaptability", desc: "Switch carriers without changing agents." },
    { title: "Comprehensive Coverage", desc: "Bundles that close the gaps most policies miss." },
    { title: "Competitive Pricing", desc: "Independent leverage on price across carriers." },
    { title: "Unbiased Advice", desc: "We work for you — not the insurance companies." },
    { title: "Personalized Service", desc: "A real person who knows your file." },
    { title: "Customer Focused", desc: "Claims, renewals, questions — always answered." },
    { title: "Long-Term Partnership", desc: "Generational relationships, built over years." },
  ],
  testimonials: [
    {
      name: "Mark",
      region: "OH",
      quote: "Damon saved me over $150/month on my car insurance.",
      photo: "https://i.pravatar.cc/240?img=12",
      rating: 5,
    },
    {
      name: "Renee",
      region: "OH",
      quote:
        "I didn't know anything about independent agents. Damon gave me a quote from four companies and I picked the coverage and price that worked best for me.",
      photo: "https://i.pravatar.cc/240?img=47",
      rating: 5,
    },
    {
      name: "Kim",
      region: "OH",
      quote:
        "Damon is very professional and answered every email quickly. He fully explained my life policy. Now I have peace of mind that my son will be taken care of.",
      photo: "https://i.pravatar.cc/240?img=45",
      rating: 5,
    },
    {
      name: "Brian",
      region: "OH",
      quote:
        "Damon reviewed my business policy and showed me where my business was vulnerable. He gave me more coverage and still saved me money. Highly recommend Knight Insurance Solutions.",
      photo: "https://i.pravatar.cc/240?img=15",
      rating: 5,
    },
    {
      name: "Tasha",
      region: "OH",
      quote:
        "Switched my auto policy through Knight and dropped my premium by $87 a month — same coverage, better company. Wish I'd called them sooner.",
      photo: "https://i.pravatar.cc/240?img=44",
      rating: 5,
    },
    {
      name: "Jerome",
      region: "OH",
      quote:
        "After my last renewal jumped, Knight shopped six carriers in one afternoon and saved me $1,940 a year on auto. Painless, professional, fast.",
      photo: "https://i.pravatar.cc/240?img=13",
      rating: 5,
    },
    {
      name: "Aisha",
      region: "OH",
      quote:
        "Bundled auto and home with Knight and cut my total bill by almost $1,200 annually. Damon walked me through every line of the policy.",
      photo: "https://i.pravatar.cc/240?img=48",
      rating: 5,
    },
    {
      name: "Greg",
      region: "OH",
      quote:
        "My old agent kept raising rates without a word. Knight requoted my two vehicles and dropped them $112/month. Independent really does mean independent.",
      photo: "https://i.pravatar.cc/240?img=59",
      rating: 5,
    },
    {
      name: "Marcus",
      region: "OH",
      quote:
        "Damon took the time to break down my whole life policy line by line. First time an agent ever explained it so I actually understood what I was paying for.",
      photo: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
      rating: 5,
    },
    {
      name: "Danielle",
      region: "OH",
      quote:
        "Knight bundled our home and auto and knocked $148 off our monthly bill — plus better coverage. Every question I've had since has been answered same day.",
      photo: "https://images.unsplash.com/photo-1580489944761-15a19d654956?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
      rating: 5,
    },
    {
      name: "Miguel",
      region: "OH",
      quote:
        "Started my small business last year and Damon set up commercial, auto and life coverage in one afternoon. Professional, bilingual when I needed it, and priced right.",
      photo: "https://images.unsplash.com/photo-1519085360753-af0119f7cbe7?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
      rating: 5,
    },
    {
      name: "Sofia",
      region: "OH",
      quote:
        "Switched our family's auto and home policies to Knight and saved just over $1,600 a year. Damon treated us like family from the very first call.",
      photo: "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?w=240&h=240&fit=crop&crop=faces&auto=format&q=80",
      rating: 5,
    },
  ],
  insuranceTypes: [
    "Auto",
    "Homeowners",
    "Life",
    "Health",
    "Business",
    "Umbrella / Specialty",
    "Other",
  ],
};
